import React from 'react';
import HeroSection from '../components/HeroSection';
import Features from '../components/Features';
import TrackRecord from '../components/TrackRecord';
import TrustedBySection from '../components/TrustedBySection';
import GetStartedForm from './GetStarted';
import SuccessStories from './SuccessStories';

function Home() {
  return (
    <div>
      <HeroSection />
      <TrustedBySection /> {/* Placing the "Trusted by" section after Features */}
      <Features />
      <TrackRecord />
      <GetStartedForm />
      {/* <SuccessStories /> */}
    </div>
  );
}

export default Home;
